module.exports = __webpack_public_path__ + "static/media/logo-256.b850cafc.png";